<input
    type="checkbox"
    [id]="id"
    (change)="handleCheckboxToggle($event)"
    #checkbox
/>
<label
    class="collapsible-checkbox-label"
    [for]="id"
    aria-live="polite"
>
    <div>
        <div
            class="label-headline block fs:l fw:bold"
            [ngClass]="{ 'm-12:b': expanded() }"
        >
            {{ label() }}
        </div>
        @if (expanded()) {
            <div [id]="id + '-expanded-content'">
                <ng-content></ng-content>
            </div>
        }
    </div>
</label>
@if (showCollapseButton()) {
    <button
        type="button"
        class="expand-icon-button"
        (click)="onButtonClick()"
        [attr.aria-label]="labelText()"
        [attr.title]="labelText()"
        [attr.aria-expanded]="expanded()"
        [attr.aria-controls]="id + '-expanded-content'"
    ></button>
}
